export function $fromParent(parentEl, string) {
  return parentEl.parent().next().find(string);
}

export function syncValues(group) {
  group.on("change", function() {
    group.val($(this).val());
  });
}

export function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}
export function eraseCookie(name) {
  document.cookie = name + "=; Max-Age=-99999999;";
}

export async function checkBandwidthSpeed() {
  const SPEED_LIMIT = 0.6;
  if (navigator.connection && navigator.connection.downlink) {
    if (navigator.connection.downlink < SPEED_LIMIT) {
      return true;
    } else {
      return false;
    }
  }
  const sampleItems = [];
  let i = 0;
  const timesToTest = 5;
  const tThreshold = 150;
  const testImage = "http://www.google.com/images/phd/px.gif";
  const dummyImage = new Image();
  let isConnectedFast = false;
  async function speedCheck(callback) {
    const tStart = new Date().getTime();
    if (i < timesToTest - 1) {
      dummyImage.src = testImage + "?t=" + tStart;
      dummyImage.onload = function() {
        const tEnd = new Date().getTime();
        const tTimeTook = tEnd - tStart;
        sampleItems[i] = tTimeTook;
        i++;
        speedCheck(callback);
      };
    } else {
      const sum = sampleItems.reduce(function(a, b) {
        return a + b;
      });
      const avg = sum / sampleItems.length;
      return callback(avg);
    }
  }
  await speedCheck(function(avg) {
    isConnectedFast = avg <= tThreshold;
    if (i === timesToTest - 1) {
      return isConnectedFast;
    }
  });
}

//WCAG Change
export function setAttrTabs(){
  setTimeout(() => {
    $('#find-a-hotel-tabs .tabs-title a').attr('tabindex','0');
    $('.making-memories .slider-wrap .slick-track button').attr('tabindex','0');
    $('#find-a-hotel-tabs .tabs-title a').attr('tabindex','0');
    $('.content-search-widget-content .close-x').attr('tabindex','0');
    $('#find-a-hotel').attr('tabindex','0');
  }, 2000);
}